import { styled } from "@woba/ds-web";

export const Wrapper = styled("div", {
  display: "flex",
  gap: "$space-03",
  alignItems: "center",
  div: {
    backgroundColor: "white",
  },
  input: {
    fontSize: "$sm",
  },
});
